export default __webpack_public_path__ + "static/media/gasoline-icon.7c115e6a.svg";